import type { ComponentProps, ReactElement, ReactNode } from 'react';
import {
  Header,
  Menu as AriaMenu,
  MenuItem as AriaMenuItem,
  MenuSection as AriaSection,
  MenuTrigger
} from 'react-aria-components';
import { Popover } from './Popover';

export function Menu({
  trigger,
  label,
  children
}: {
  trigger: ReactElement;
  label: string;
  children: ReactNode;
}): ReactElement {
  return (
    <MenuTrigger>
      {trigger}
      <Popover placement="bottom end">
        <AriaMenu
          aria-label={label}
          className="min-w-[12rem] m-0 p-1 border-0 bg-panel text-ink font-ui text-md outline-none"
        >
          {children}
        </AriaMenu>
      </Popover>
    </MenuTrigger>
  );
}

export function MenuItem(props: Omit<ComponentProps<typeof AriaMenuItem>, 'className'>): ReactElement {
  return (
    <AriaMenuItem
      {...props}
      className="flex items-center no-underline m-0 px-3 py-2 touch:min-h-[44px] border-0 rounded-control bg-transparent text-ink font-ui text-md cursor-default outline-none data-[focused]:bg-desk"
    />
  );
}

export function MenuSection({ title, children }: { title?: string; children: ReactNode }): ReactElement {
  return (
    <AriaSection className="m-0 p-0 border-0">
      {title ? (
        <Header className="m-0 px-3 py-1 border-0 bg-transparent text-xs font-ui text-muted">{title}</Header>
      ) : null}
      {children}
    </AriaSection>
  );
}
